import React from "react";
import {
  CgPushChevronLeft,
  CgPushChevronRight,
  CgChevronLeft,
  CgChevronRight,
} from "react-icons/cg";
import { Col } from "react-bootstrap";

export const Pagination = ({ totalPages, page, pageHandler, totalTasks, tasksShowing }) => {
  return (
    <>
      {" "}
      <Col lg={6} sm={12}>
        <div className="flex pagination">
          <div style={{ margin: "7px", minWidth: "120px" }}>
            {tasksShowing + " of " + totalTasks + " Tasks" /* show current page and total pages*/}
          </div>
          <button className="page-link" disabled={page === 1} onClick={() => pageHandler(1)}>
            <CgPushChevronLeft />
          </button>
          <button className="page-link" disabled={page === 1} onClick={() => pageHandler(page - 1)}>
            <CgChevronLeft />
          </button>
          <div style={{ margin: "7px 1px", minWidth: "100px" }}>
            {"Page " + page + " of " + totalPages /* show current page and total pages*/}
          </div>
          <button
            className="page-link"
            disabled={page === totalPages}
            onClick={() => pageHandler(page + 1)}
          >
            <CgChevronRight />
          </button>
          <button
            className="page-link"
            disabled={page === totalPages}
            onClick={() => pageHandler(totalPages)}
          >
            <CgPushChevronRight />
          </button>
        </div>
      </Col>
    </>
  );
};

export default Pagination;
